import {setAllContent,setPolls,setFilteredContent, setQnas, setPosts, setVideos, setFeedLoader, setFilteredVideos } from '../actions/index';

export const fetchAllContent = () => (dispatch,getState) => {
      var myHeaders = ({
        'Accept' : 'application/json',
        'Content-Type': 'application/json'
    });
    let uid = getState().info.info.uid;

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body:JSON.stringify({uid}),
      redirect: 'follow'
    };
    dispatch(setFeedLoader(true))

    return fetch("https://recruitingmonk-v2.azurewebsites.net/feed", requestOptions)
        .then(response => {
            if(response.ok) {
                console.log(response)
                return response;
            }
            else {
                var error = new Error("Error " + response.status + ": " + response.statusText);
                error.response = response;
                throw error;
            }
        }, 
        error => {
            var errmess = new Error(error.message);
            throw errmess;
        })
        .then(response => response.json())
        .then(data => {
            let videos = [],posts = [],polls = [],qnas = [];
            for(let item of data.feed){
                if(item.tag === 'video')
                    videos.push(item);
                else if(item.tag === 'post')
                    posts.push(item);
                else if(item.tag === 'poll')
                    polls.push(item);
                else if(item.tag === 'qna')
                    qnas.push(item)
            }
            dispatch(setVideos(videos))
            dispatch(setPosts(posts))
            dispatch(setPolls(polls))
            dispatch(setQnas(qnas))
            dispatch(setFilteredVideos(videos));
            dispatch(setAllContent(data.feed))
            dispatch(setFilteredContent(data.feed))
            dispatch(setFeedLoader(false));
        })
        .catch((error) => {
            dispatch(setFeedLoader(false));
            console.log(error)
        });
}